__turbopack_context__.v({
  "drawer": "k0yStG_drawer",
  "drawer-wrapper": "k0yStG_drawer-wrapper",
  "drawer__actions": "k0yStG_drawer__actions",
  "drawer__close-button": "k0yStG_drawer__close-button",
  "fadeIn": "k0yStG_fadeIn",
  "slideIn": "k0yStG_slideIn",
});
